import { getOpenThermStateName } from 'openTherm';
export function convertOTFlag(flag, ot_value, has, not) {
    return {
        ot_name: getOpenThermStateName(flag, 'ru'),
        display_value: ot_value.includes(flag) ? has : not,
        value: ot_value.includes(flag),
    };
}
